import React from 'react'
import virual from '../assests/virual.png'
import { Homepage } from '../constants/index'
import {Foot} from '../constants/index'
function Home() {
  return (
    <section className='w-full h-[750px] bg-slate-700 relative -z-20 '>
    <div className='relative full h-[185px] bg-[#AE0243] -z-10 rounded-b-2xl'>
         <img src={virual} alt='virual' className='ml-[35%] absolute'/>
            <h1 className='relative top-3 leading-9 pl-10 text-[29px] font-bold text-white'>Events <br/> Media<br/> Intelligence</h1>
            <h3 className='text-center text-[32px] relative  top-2 tracking-tight text-white'>for a better world</h3>
    </div>
    
        <div>
            <h1 className='text-[26px] font-semibold pl-10 pt-2 text-white'>Upcoming Events</h1>
        </div>
     
        {
            Homepage.map((ele,ind)=>(
        <div className='w-[327px] h-[150px]  bg-white mb-4 flex flex-row justify-between rounded-2xl mt-4 mx-auto'>
            <div className='w-[100px] mt-2 pl-3'>
             <img src={ele.img1} alt='img1' className='absolute'/>
             <img src={ele.img2} alt='img2' className='relative top-7 left-5'/>
            </div>
            <div className='w-[200px] h-[200px] '>
                <h1 className='mt-4 font-bold'>{ele.furm}</h1>
                <p >{ele.dates}</p>
                <p className='w-[200px] tracking-tighter'>{ele.loc}</p>
            </div>
        </div>
        ))
        }
    
        <div className='w-full rounded-t-2xl grid grid-cols-5 absolute z-10 bg-white  '>
    {
        
      Foot.map((fot,i)=>(
        <div className='w-full h-16 ml-10 bg-white pt-6'>
           <img src={fot.im} alt='footer' className='w-[39px] h-[30px] ml-4  '/>
     </div>
      ))  
      
    }
    </div>

    </section>
  )
}

export default Home
